import { render } from "./Generality.vue?vue&type=template&id=0832cde7&scoped=true"
import script from "./Generality.vue?vue&type=script&lang=js"
export * from "./Generality.vue?vue&type=script&lang=js"

import "./Generality.vue?vue&type=style&index=0&id=0832cde7&scoped=true&lang=css"

import exportComponent from "/var/www/html/remote/eeia-spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0832cde7"]])

export default __exports__